<template>
  <div>
    <Catalog
        v-for="catalog in data"
        :key="catalog.id"
        :catalog="catalog"
        :items="items"
        :updatePrescription="updatePrescription" />
  </div>
</template>

<script>
  import Catalog from './Catalog';

  export default {
    name: 'CheckupPrescriptions',

    components: {Catalog},

    props: ['catalogs', 'items', 'updatePrescription'],

    data() {
      return {};
    },

    computed: {
      data() {
        const catalogs = this.catalogs.map(catalog => {
          catalog.inner = [];

          return catalog;
        });

        catalogs.sort((a, b) => a.sort - b.sort);

        catalogs.forEach(catalogParent => {
          catalogs.forEach(catalogChild => {
            if (catalogChild.parent === catalogParent.id && catalogChild.parent !== null) {
              catalogParent.inner.push(catalogChild);
            }
          });
        });

        return catalogs.filter(catalog => catalog.parent === null);
      },
    },

    methods: {},
  };
</script>
